import { computeTier } from '@flintmint/core-shared/utils';

import { Badge } from '@/components/badge';
import { subscriptionStatusLabels, subscriptionStatusTones, tierLabels, tierTones } from './billing-display';
import { StripeCustomerLink } from './stripe-customer-link';
import type { UserRow } from './use-users';

import styles from './plan-cell.module.scss';

export const PlanCell = ({ row }: { row: UserRow }) => {
  if (row.agreementsPending) return <Badge label="Agreements pending" tone="outline" />;

  const { account } = row;
  const subscription = account?.stripeSubscription;
  const tier = computeTier(account ?? undefined);

  return (
    <div className={styles.cell}>
      {subscription ? (
        <>
          {subscription.planName}
          <Badge label={subscriptionStatusLabels[subscription.status]} tone={subscriptionStatusTones[subscription.status]} />
        </>
      ) : (
        <Badge label={tierLabels[tier]} tone={tierTones[tier]} />
      )}
      {account?.stripeCustomerId && <StripeCustomerLink customerId={account.stripeCustomerId} label="Stripe" />}
    </div>
  );
};
